import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConstructionDocumentItem } from '../../entities/construction-documents-entities';
import { ConstructionDocumentsService } from '../../service/construction-documents.service';
import { getSelectedFile } from '../folder-content-helper';

@Component({
  selector: 'app-download-file-confirmation-modal',
  templateUrl: './download-file-confirmation-modal.component.html',
  styleUrl: './download-file-confirmation-modal.component.scss',
  standalone: false,
})
export class DownloadFileConfirmationModalComponent implements OnInit {
  private readonly constructionDocumentsService = inject(
    ConstructionDocumentsService,
  );

  @Output() proceedDownload = new EventEmitter<ConstructionDocumentItem>();

  file$ = new BehaviorSubject<ConstructionDocumentItem | null>(null);
  modalState$ = new BehaviorSubject(false);

  ngOnInit(): void {
    this.file$.next(getSelectedFile());
  }

  proceedModal() {
    const file = this.file$.getValue();
    file && this.proceedDownload.emit(file);
    this.closeModal();
  }

  closeModal() {
    this.constructionDocumentsService.setModalState(false);
  }
}
